import React, { type FC, type PropsWithChildren } from 'react';

type WaveSVGProps = {
  /** Allows the component to get additional styles. */
  className?: string;
};

const WaveSVG: FC<PropsWithChildren<WaveSVGProps>> = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="100%"
    viewBox="0 0 1440 50"
    width="100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 11.2069C133 30.6036 219 26.7241 313 11.2069C407 -4.31029 579.001 36.4138 723 11.2069C867 -14 933 36.4224 1123 11.2069C1313 -14.0086 1440 11.2069 1440 11.2069V50H0V11.2069Z" />
  </svg>
);

export default WaveSVG;
